import { UserCheck, Zap, Award, Eye } from "lucide-react";

const reasons = [
  {
    icon: UserCheck,
    title: "Proximité",
    description:
      "Un interlocuteur dédié qui connaît votre dossier. Nous privilégions la relation humaine et la disponibilité.",
  },
  {
    icon: Zap,
    title: "Réactivité",
    description:
      "Des réponses rapides et un suivi régulier de votre comptabilité. Vous n'attendez pas des semaines pour une réponse.",
  },
  {
    icon: Award,
    title: "Expertise complète",
    description:
      "De l'indépendant à la SA, nous maîtrisons toutes les formes juridiques et les spécificités fiscales suisses.",
  },
  {
    icon: Eye,
    title: "Transparence",
    description:
      "Des tarifs clairs, sans surprise. Vous savez exactement ce que vous payez et pour quel service.",
  },
];

const WhyUs = () => {
  return (
    <section
      id="pourquoi-nous"
      className="py-20 md:py-28 bg-white"
      aria-labelledby="whyus-title"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-left mb-12 md:mb-16">
          <h2
            id="whyus-title"
            className="text-3xl md:text-4xl font-semibold text-gray-900 tracking-tight font-['Manrope']"
          >
            Pourquoi choisir Performance Transmission ?
          </h2>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
          {reasons.map((reason, index) => (
            <div
              key={reason.title}
              className="flex gap-5"
              data-testid={`reason-${index}`}
            >
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-lg bg-blue-50">
                <reason.icon
                  className="w-6 h-6 text-blue-600"
                  strokeWidth={1.5}
                  aria-hidden="true"
                />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 font-['Manrope'] mb-2">
                  {reason.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
